<div class="panneau-ordonnance__container">
	<div class="container__content">
		<di-form-ordonnance
		[ordonnance]="ordonnance"
		[patient]="patient"
		mode="edit"
		[isPanneau]="true"
		(updateOrCreateOrdonnance)="handleSaveOrdonnance()"
		></di-form-ordonnance>
	</div>
</div>